var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorHandle = function SvgDoorHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    className: "door-handle_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c9f24",
    d: "M706.4 482.2v362.1c0 61.5-49.9 111.3-111.4 111.3H260.8c-61.5 0-111.4-49.8-111.4-111.5V176c0-61.6 49.9-111.5 111.4-111.5H595c61.5 0 111.4 50.1 111.4 111.3v139.3h83.5c46.2 0 83.5 37.2 83.5 83.5 0 46.2-37.3 83.5-83.5 83.5h-83.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M400.1 398.7c0 15.5 12.4 27.8 27.9 27.8h362c15.5 0 27.9-12.4 27.9-27.8 0-15.5-12.4-27.8-27.9-27.8H428c-15.6-.1-27.9 12.3-27.9 27.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M539.3 315.1c-25.7-34.2-66.5-55.7-111.4-55.7-76.9 0-139.2 62.3-139.2 139.2S351 537.9 427.9 537.9c44.9 0 85.7-21.5 111.4-55.7H427.9c-46.2 0-83.5-37.2-83.5-83.5 0-46.2 37.3-83.5 83.5-83.5h111.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M650.7 315.1V175.8c0-30.6-25-55.6-55.7-55.6H260.8c-30.7 0-55.7 25-55.7 55.8v668.1c0 30.9 24.9 55.8 55.7 55.8H595c30.7 0 55.7-24.9 55.7-55.6V482.2h-78c-28.9 49.9-82.9 83.5-144.7 83.5-92.3 0-167.1-74.8-167.1-167.1S335.7 231.5 428 231.5c61.8 0 115.8 33.6 144.7 83.5h78z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c9f24",
    d: "M427.9 788.6c-46.1 0-83.5-37.4-83.5-83.5s37.4-83.5 83.5-83.5 83.5 37.4 83.5 83.5c0 46-37.4 83.5-83.5 83.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M427.9 760.7c30.8 0 55.7-24.9 55.7-55.7s-24.9-55.7-55.7-55.7-55.7 24.9-55.7 55.7 24.9 55.7 55.7 55.7"
  })));
};
export default SvgDoorHandle;